import * as CryptoJS from 'crypto-js'
/**
 *加密处理
 */
export const encryption = (params) => {
  let {
    data,
    type,
    param,
    key
  } = params
  const result = JSON.parse(JSON.stringify(data))
  if (type === 'Base64') {
    param.forEach(ele => {
      result[ele] = btoa(result[ele])
    })
  } else {
    param.forEach(ele => {
      var data = result[ele]
      key = CryptoJS.enc.Latin1.parse(key)
      var iv = key
      // 加密
      var encrypted = CryptoJS.AES.encrypt(
        data,
        key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.ZeroPadding
        })
      result[ele] = encrypted.toString()
    })
  }
  return result
}

/**
 * @description 加密
 * @author ricky
 * @param String
 * @return String
 */
export const encrypt = (obj) => {
	let params = {
		data: { username: obj.username, password: obj.password, vcode: "1234", randomStr: "202003311257" },
		key: 'lanmax_mp_v30_20',
		param: ['password']
	}
	const user = encryption(params) //返回一个结果
	return user
};


// WEBPACK FOOTER //
// ./src/api/lanmax-web-common.js